import store from '@/state/store';

export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard'),
  },
  {
    path: '/unit/:unitId',
    name: 'unit-detail',
    component: () => import('@/views/unit/UnitDetail'),
  },
  {
    path: '/unit/:unitId/building/:buildingId/',
    name: 'building-detail',
    component: () => import('@/views/building/BuildingDetail'),
  },
  // {
  //   path: '/unit/:unitId/building/:buildingId/:mode',
  //   name: 'building-detail',
  //   component: () => import('@/views/building/BuildingDetail'),
  // },
  {
    path: '/unit/:unitId/building/:buildingId/device/:deviceId',
    name: 'device-detail',
    component: () => import('@/views/device/DeviceDetail'),
  },
  {
    path: '/health-pad',
    name: 'health-pad',
    component: () => import('@/views/healthpad/HealthPad'),
  },

  // {
  //   path: '/dashboard',
  //   redirect: '/fields',
  // },
  // {
  //   path: '/fields',
  //   name: 'fields',
  //   component: () => import('@/views/field/FieldList'),
  // },
  // {
  //   path: '/fields/:fieldId',
  //   name: 'field-detail',
  //   component: () => import('@/views/field/FieldDetail'),
  // },
  // {
  //   path: '/fields/:fieldId/blocks/:blockId',
  //   name: 'block-detail',
  //   component: () => import('@/views/field/block/BlockDetail'),
  // },
  // {
  //   path: '/devices',
  //   name: 'devices',
  //   component: () => import('@/views/device/DeviceList'),
  // },
  // {
  //   path: '/devices/:deviceId',
  //   name: 'device-detail',
  //   component: () => import('@/views/device/DeviceDetail'),
  // },
  // {
  //   path: '/history',
  //   name: 'history-field-list',
  //   component: () => import('@/views/history/HistoryFieldList'),
  // },
  // {
  //   path: '/history/:fieldId',
  //   name: 'history-block-list',
  //   component: () => import('@/views/history/HistoryBlockList'),
  // },
  // {
  //   path: '/history/:fieldId/blocks/:blockId',
  //   name: 'history-detail',
  //   component: () => import('@/views/history/HistoryDetail'),
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/account/login'),
  // },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter() {
      store.dispatch('auth/userLogout');
    },
  },
  {
    path: '/404',
    name: '404',
    // eslint-disable-next-line global-require
    component: require('@/views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
];
